import { DeviceLabels } from 'frontend/constants/chime';
import { action } from '@ember/object';
import { reads } from '@ember/object/computed';
import { tracked } from 'tracked-built-ins';
import Service, { service } from '@ember/service';
import classic from 'ember-classic-decorator';

@classic
export default class ChimeLocalAudioVideoService extends Service {
  @service('chime.meeting-manager') meetingManager;
  @service persistentProperties;

  @tracked tileId = null;

  @reads('persistentProperties.isVideoPublished') isVideoPublished;
  @reads('persistentProperties.isAudioPublished') isAudioPublished;

  init(_properties) {
    super.init(_properties);
    this.meetingManager.subscribeToAudioVideo(this.onAudioVideoChange);
  }

  async toggleVideo() {
    if (this.isVideoPublished) {
      await this.meetingManager.stopVideoInput();
    } else {
      await this.meetingManager.startVideoInputDevice();
    }
    this.persistentProperties.setProp('isVideoPublished', !this.isVideoPublished);
  }

  @action
  videoTileDidUpdate(tileState) {
    if (
      !this.meetingManager.audioVideo ||
      !tileState.localTile ||
      !tileState.tileId ||
      this.tileId === tileState.tileId
    )
      return;

    this.tileId = tileState.tileId;
  }

  @action
  videoTileWasRemoved(tileId) {
    if (tileId !== this.tileId) return;

    this.tileId = null;
  }

  @action
  bindLocalVideo(videoElement) {
    this.meetingManager.audioVideo.bindVideoElement(this.tileId, videoElement);
  }

  @action
  onMutedStateChange(localMuted) {
    this.persistentProperties.setProp('isAudioPublished', !localMuted);
  }

  get deviceLabels() {
    let { isVideoPublished, isAudioPublished } = this;

    switch (true) {
      case isVideoPublished && isAudioPublished:
        return DeviceLabels.AudioAndVideo;
      case isVideoPublished:
        return DeviceLabels.Video;
      case isAudioPublished:
        return DeviceLabels.Audio;
      default:
        return DeviceLabels.None;
    }
  }

  @action
  onAudioVideoChange(audioVideo) {
    if (!audioVideo) {
      this.tileId = null;
      return;
    }

    audioVideo.addObserver({
      videoTileDidUpdate: this.videoTileDidUpdate,
      videoTileWasRemoved: this.videoTileWasRemoved,
    });
    audioVideo.realtimeSubscribeToMuteAndUnmuteLocalAudio(this.onMutedStateChange);

    if (!this.isAudioPublished) {
      audioVideo.realtimeMuteLocalAudio();
    }
  }
}
